import { ChangeEvent } from "react";
import { SelectOption } from "@iddataweb/idw-common-ui/types";
import { resources } from "@constants/hardcoded-strings";
import { LabelWidthTypes } from "@enums/label-width-types";
import { AxnCompany, AxnRelyingParty } from "@idw-types/data/reference-data/axn";
import { InputFormGroup } from "../../../common/input-form-group/input-form-group";
import { CommonWorkflowConfigurationSection } from "../common-workflow-configuration-section/common-workflow-configuration-section";
import { WorkflowImportValidationContainer } from "../workflow-import-validation-container/workflow-import-validation-container";
import { EntityImportValidationError } from "@idw-types/data/entity-import-validation-error";

type ImportWorkflowSectionProps = {
    validationComplete: boolean;
    importErrors: { [key: string]: Array<EntityImportValidationError> };
    selectedFileJSON: any;
    labelWidth: LabelWidthTypes;
    canAddNewRelyingParty: boolean;
    canAddRelyingPartyDueToLimits: boolean;
    requestInProgress: boolean;
    axnCompanies: Array<AxnCompany>;
    availableRelyingParties: Array<AxnRelyingParty>;
    workflowName: string;
    selectedWorkflowOrganizationOption: SelectOption;
    selectedWorkflowRelyingPartyOption: SelectOption;
    selectedFileName: string;
    workflowRedirectUrls: Array<string>;
    handleUpdateFile: (event: ChangeEvent<HTMLInputElement>) => void;
    onAddRelyingPartySuccess: (newAxnRelyingParty: AxnRelyingParty) => void;
    handleUpdateWorkflowName: (event: ChangeEvent<HTMLInputElement>) => void;
    handleUpdateWorkflowOrganization: (newOption: SelectOption) => void;
    handleUpdateWorkflowRelyingParty: (newOption: SelectOption) => void;
    handleUpdateWorkflowRedirectUrl: (event: ChangeEvent<HTMLInputElement>, index: number) => void;
    onClickAddRedirectUrl: () => void;
    removeWorkflowRedirectUrl: (index: number) => void;
};

export const ImportWorkflowSection = (props: ImportWorkflowSectionProps) => {
    const {
        validationComplete,
        importErrors,
        selectedFileJSON,
        labelWidth,
        canAddNewRelyingParty,
        canAddRelyingPartyDueToLimits,
        requestInProgress,
        axnCompanies,
        availableRelyingParties,
        workflowName,
        selectedWorkflowOrganizationOption,
        selectedWorkflowRelyingPartyOption,
        selectedFileName,
        workflowRedirectUrls,
        handleUpdateFile,
        onAddRelyingPartySuccess,
        handleUpdateWorkflowName,
        handleUpdateWorkflowOrganization,
        handleUpdateWorkflowRelyingParty,
        handleUpdateWorkflowRedirectUrl,
        onClickAddRedirectUrl,
        removeWorkflowRedirectUrl
    } = props;

    const resource = resources.modals.addVerificationWorkflow;

    return (
        <div>
            <InputFormGroup
                controlId="verification-workflow-file-input"
                label={resource.inputs.file.label}
                ariaLabel={resource.inputs.file.label}
                automationId="verification-workflow-file-input"
                value={selectedFileName}
                type={"file"}
                accept={"application/json"}
                onChange={handleUpdateFile}
                disabled={requestInProgress}
                isRequired={true}
                labelWidth={labelWidth}
            />
            {validationComplete && (
                <WorkflowImportValidationContainer
                    importErrors={importErrors}
                    jsonContent={selectedFileJSON}
                />
            )}
            {validationComplete && Object.keys(importErrors).length === 0 && (
                <>
                    <hr />
                    <CommonWorkflowConfigurationSection
                        axnCompanies={axnCompanies}
                        canAddNewRelyingParty={canAddNewRelyingParty}
                        canAddRelyingPartyDueToLimits={canAddRelyingPartyDueToLimits}
                        availableRelyingParties={availableRelyingParties}
                        workflowName={workflowName}
                        selectedWorkflowOrganizationOption={selectedWorkflowOrganizationOption}
                        selectedWorkflowRelyingPartyOption={selectedWorkflowRelyingPartyOption}
                        workflowRedirectUrls={workflowRedirectUrls}
                        onAddRelyingPartySuccess={onAddRelyingPartySuccess}
                        handleUpdateWorkflowName={handleUpdateWorkflowName}
                        handleUpdateWorkflowOrganization={handleUpdateWorkflowOrganization}
                        handleUpdateWorkflowRelyingParty={handleUpdateWorkflowRelyingParty}
                        handleUpdateWorkflowRedirectUrl={handleUpdateWorkflowRedirectUrl}
                        onClickAddRedirectUrl={onClickAddRedirectUrl}
                        removeWorkflowRedirectUrl={removeWorkflowRedirectUrl}
                        labelWidth={labelWidth}
                        requestInProgress={requestInProgress}
                    />
                </>
            )}
        </div>
    );
};